<template>
	<div v-bind:id="id">
        <div class="head-title">
            <div class="title-style">{{headTitle}}</div>
            <div class="count-selected -wrapper-column h-center- -pl-1">
                <div class="-badge -badge-GNB small -bg-gray-1" style="height: 18px;">
                    {{ countSelect ? getTotalSelected() : totalData}}
                </div>
            </div>
        </div>
        <div style="border :1px solid #D3D8E0;">
            <div input-search>
                <div class="-wrapper">
                    <div class="-wrapper v-center-" style="width: 100%">
                        <div class="-search-bar" style="width: 100%">
                            <span class="-search-icon">
                                <span class="material-icons">search</span>
                            </span>
                            <input type="search" v-model="searchTxt" style="width: 100%" class="-search" :placeholder="$t('COMMON.SEARCH.SEARCH_ANYTHING')">
                            <button type="button" class="-btn borderless- small- icon-only-" v-bind:class="searchTxt == '' ? 'close-' : ''" @click="resetSearchText()">
                                <span class="material-icons">close</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div-loading v-if="isLoading"></div-loading>
            <div data-result class="data-result" v-bind:style="{height: height}">
                <GroupItem v-for="(region) of options" 
                    :key="id + region.id" 
                    :region="region" 
                    :id="id"
                    :searchTxt="searchTxt"
                    :callSetSelectedValue="callSetSelectedValue"
                    :preSelectedValue="groupValue[region.id]"
                />
            </div>
        </div>
    </div>
</template>

<script>

import GroupItem from "./GroupItem.vue"
export default {
	name: "GroupSelect",
    components: {GroupItem},
	props:{
		headTitle:  {
			type: String,
			default: "Selected"
		},
		preSlctedValue: {
			type: Array,
			default: ()=>[]
		},
		callGetValue: {
			type: Function,
			default: ()=>{}
		},
		options: {
			type: Array,
			default:()=>[]
		},
        id: {
			type: String,
			default: "group-select"
		},
        height: {
			type: String,
			default: ""
		},
        countSelect: {
			type: Boolean,
			default: true
		},
        isLoading: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
            value: [],
			groupValue: {},
            listGroup: [],
            searchTxt: "",
            totalData: 0,
		}
    },
	mounted() {
        this.getTotalData();
        this.getGroupValue();
	},
	watch: {
        options(){
            this.getTotalData();
            this.getGroupValue();
        }
	},
	methods: {
		callSetSelectedValue(groupId, selectedValue) {
            this.groupValue[groupId] = selectedValue;
            let keys = Object.keys(this.groupValue);
            let value = [];
            keys.forEach(key => {
                value = value.concat(this.groupValue[key]);
            });
            this.value = value;
            this.callGetValue(this.value);
        },
        resetSearchText() {
            this.searchTxt = "";
        },
        countSelected(groupId) {
            let count = 0;
            this.options.forEach(e => {
                if (e.id === groupId) {
                    e.children.forEach(item => {
                        let index = this.value.indexOf(item.id);
                        if (index !== -1) {
                            count++;
                        }
                    });
                }
            });
            return count;
        },
        getTotalData() {
            let total = 0;
            this.options.forEach(e => {
                total = total + e.children.length;
            });
            this.totalData = total;
        },
        getGroupValue() {
            let groupValue = {};
            (this.options || []).forEach(groupItem => {
                let groupId = groupItem.id;
                let selectedValue = [];
                let listItemId = (groupItem.children || []).map(item => item.id);

                listItemId.forEach(item => {
                    if (_.includes(this.preSlctedValue, item)) {
                        selectedValue.push(item);
                    }
                });

                groupValue[groupId] = selectedValue;
            });

            this.groupValue = _.cloneDeep(groupValue);
        },
        getTotalSelected() {
            let keys = Object.keys(this.groupValue);
            let total = 0;
            keys.forEach(key => {
                let value = this.groupValue[key];
                total = total + value.length;
            });
            return total;
        }
	}
}
</script>
<style scoped>
.select-item {
    border-bottom: 1px solid #D3D8E0;
    position: relative;
}
.group-head {
    padding: 4px 8px;
    background-color: #f5f7f9;
    border-bottom: 1px solid #D3D8E0;
    position: relative;
}
.head-title {
    padding: 5px 0px;
}
.title-style, .count-selected {
    display: inline-block;
}
.data-result {
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
}
.-search-bar .-search {
    min-width: unset;
}
</style>


// WEBPACK FOOTER //
// src/components/common/GroupSelect/GroupSelect.vue